module.exports = __webpack_public_path__ + "img/activate.db34b1ab.svg";